@if (adSlides && adSlides.length !== 0) {
	<app-tiny-slider [sliderConfig]="adSliderSettings">
		@for (adSlide of adSlides; track adSlide) {
			<div
				class="login-ad-slider"
				[ngStyle]="{
					'background-color': adSlide.BACKGROUND_COLOR,
					color: adSlide.FONT_COLOR,
					'background-image':
						adSlide
						| adaptiveImageSource: screenMode
						| imageSourceContext: 'backgroundImage',
				}"
			>
				<app-login-header
					[context]="'ad-slider'"
					[logoColor]="adSlide.FONT_COLOR"
				></app-login-header>
				<section
					class="login-ad-slider__content"
					[ngStyle]="{ color: adSlide.FONT_COLOR }"
				>
					<h2
						class="login-ad-slider__title"
						[ngStyle]="{
							'background-color': adSlide.TEXT_BACKGROUND_COLOR,
							'outline-color': adSlide.TEXT_BACKGROUND_COLOR,
						}"
					>
						{{ adSlide.BANNER_TITLE }}
					</h2>
					<p class="login-ad-slider__text-block">
						<span
							class="login-ad-slider__text-wrapper"
							[ngStyle]="{
								'background-color': adSlide.TEXT_BACKGROUND_COLOR,
								'outline-color': adSlide.TEXT_BACKGROUND_COLOR,
							}"
						>
							<span class="login-ad-slider__text">
								{{ adSlide.BANNER_SUBTITLE }}
							</span>
						</span>
					</p>
				</section>
			</div>
		}
	</app-tiny-slider>
}
